import React from 'react';
import { AvatarLinkComponentProps } from '@/components/features/cms/blocks/AvatarLink/register';
import { AvatarLink as DSAvatarLink } from '@/components/shared';

export const AvatarLink: React.FunctionComponent<AvatarLinkComponentProps> = ({ image, linkTitle, linkUrl }) => {
	return <DSAvatarLink linkTitle={linkTitle} image={{ size180: { url: image } }} linkUrl={linkUrl} />;
};
